import request from "@/http/request"
import {
    getOtsManagePages
} from '@/http/api'

export const goOtsAdminHome = (data) => {
    return request({
        url: getOtsManagePages,
        data
    })
}